import { render, staticRenderFns } from "./CreaReporte.vue?vue&type=template&id=6afd2e71"
import script from "./CreaReporte.vue?vue&type=script&lang=js"
export * from "./CreaReporte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports